/*
  M365 card swatches.
  Desktop (hover-capable pointers): hovering a swatch previews that colour's
  image on the card. Leaving the swatch row restores the original image.
  Clicking a swatch goes to the product with that colour selected.
  Touch devices: tap goes straight to the product, no preview.
*/
if (!customElements.get('m365-card-swatches')) {
  customElements.define(
    'm365-card-swatches',
    class M365CardSwatches extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        this.cardWrapper = this.closest('.card-wrapper');
        if (!this.cardWrapper) return;

        this.image = this.cardWrapper.querySelector('.card__media .media > img');
        if (!this.image) return;

        this.original = {
          src: this.image.getAttribute('src'),
          srcset: this.image.getAttribute('srcset'),
        };

        this.querySelectorAll('.m365-card-swatch[data-src]').forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => this.preview(swatch));
          swatch.addEventListener('focus', () => this.preview(swatch));
        });

        this.addEventListener('mouseleave', () => this.reset());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.reset();
        });
      }

      preview(swatch) {
        this.setImage(swatch.dataset.src, swatch.dataset.srcset);
        this.cardWrapper.classList.add('m365-swatch-preview');
        this.querySelectorAll('.m365-card-swatch.is-active').forEach((el) => el.classList.remove('is-active'));
        swatch.classList.add('is-active');
      }

      reset() {
        this.setImage(this.original.src, this.original.srcset);
        this.cardWrapper.classList.remove('m365-swatch-preview');
        this.querySelectorAll('.m365-card-swatch.is-active').forEach((el) => el.classList.remove('is-active'));
      }

      setImage(src, srcset) {
        if (!src) return;
        if (srcset && srcset.trim()) {
          this.image.setAttribute('srcset', srcset.trim());
        } else {
          this.image.removeAttribute('srcset');
        }
        this.image.setAttribute('src', src);
      }
    }
  );
}
